import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { type BillStage } from '@/lib/stage-utils';
import { StageQueueView } from './stage/StageQueueView';
import { StageSourcesPanel } from './stage/StageSourcesPanel';
import { StageRulesSettings } from './stage/StageRulesSettings';
import { StageActivityLogs } from './stage/StageActivityLogs';
import { ProcessingQueuePanel } from './stage/processing/ProcessingQueuePanel';

interface StageTabsProps {
  stage: BillStage;
}

export function StageTabs({ stage }: StageTabsProps) {
  const showProcessingQueue = stage === 'processing';

  return (
    <Tabs defaultValue="queue" className="w-full">
      <TabsList className="grid w-full grid-cols-4">
        <TabsTrigger value="queue">Queue</TabsTrigger>
        <TabsTrigger value="sources">Sources / Add</TabsTrigger>
        <TabsTrigger value="rules">Rules & Settings</TabsTrigger>
        <TabsTrigger value="activity">Activity & Logs</TabsTrigger>
      </TabsList>

      <TabsContent value="queue" className="space-y-4">
        {showProcessingQueue ? <ProcessingQueuePanel /> : <StageQueueView stage={stage} />}
      </TabsContent>

      <TabsContent value="sources" className="space-y-4">
        <StageSourcesPanel stage={stage} />
      </TabsContent>

      <TabsContent value="rules" className="space-y-4">
        <StageRulesSettings stage={stage} />
      </TabsContent>

      <TabsContent value="activity" className="space-y-4">
        <StageActivityLogs stage={stage} />
      </TabsContent>
    </Tabs>
  );
}
